import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { PersonalizationsService } from '../../base/services/personalizations/personalizations.service';
import { Environment } from '../../models/environment';
import { routeAccessList } from '../../base/variables/roles-access-list';
import { ProfileService } from '../profile/profile.service';

@Injectable({
  providedIn: 'root'
})
export class RoleGuardService implements CanActivate {

  environment: Environment;

  constructor(
    private _personalization: PersonalizationsService,
    private _profile: ProfileService,
    private _router: Router
  ) {
    this.environment = this._personalization.sendEnv;
   }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    let roles = next.data.role || [];
    if (this.environment.features.customProfileAccess) {
      let url = state.url;
      localStorage.setItem('actualURL', state.url);
      if (next.paramMap.get('id')) {
        localStorage.setItem('detailId', next.paramMap.get('id'));
        const temp = state.url.split('/');
        temp.pop();
        url = temp.join('/');
      }
      if (localStorage.getItem('detailId') && localStorage.getItem('actualURL')) {

        const actualURL = localStorage.getItem('actualURL');

        if (actualURL === url) {

          const id = state.url.split('/').reverse();

          if (id[0] === localStorage.getItem('detailId')) {
            const temp = state.url.split('/');
            temp.pop();
            url = temp.join('/');
          } else {
            localStorage.removeItem('detailId');
          }

        }
      } else {
        while (!(url in routeAccessList)) {
          const temp = url.split('/');
          temp.pop();
          url = temp.join('/');
        }
      }

      roles = routeAccessList[url];

    }

    const userRole = +this._profile.getUserProperty('idPerfil');
    const home = this.environment.login.home || 'tasks/pending';
    if (!roles.includes(userRole)) {
      this._router.navigate([home]);
      return false;
    }

    return true;
  }

}
